import React, { useCallback, useMemo } from 'react';

import { useGetCourseGroupsQuery } from '@classCreation/services/courseGroupsService';
import Select from 'components/Select';

function CourseGroupSelect({ ...props }) {
  const { isLoading, error, data, refetch } = useGetCourseGroupsQuery();

  const options = useMemo(() => {
    if (data?.data) {
      return data.data.map((courseGroup) => ({
        label: courseGroup.name,
        value: courseGroup.id,
      }));
    } else {
      return [];
    }
  }, [data]);

  const noOptionsMessage = useCallback(() => {
    if (isLoading) {
      return 'Loading TA skills...';
    } else if (error) {
      return 'Failed to load TA skills.';
    } else {
      return 'No matching TA skill found.';
    }
  }, [isLoading, error]);

  return (
    <>
      <Select
        noOptionsMessage={noOptionsMessage}
        options={options}
        placeholder="Select TA Skill"
        {...props}
      />
      {error && !isLoading && (
        <div className="m-t-xxs h6 hint">
          Failed to load TA skills.
          <span
            className="danger m-l-xxs cursor"
            onClick={refetch}
          >
            Try again
          </span>
        </div>
      )}
    </>
  );
}

export default CourseGroupSelect;
